export class CompareBatchFileReadException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CompareBatchFileReadException';
  }
}
